<template>
  <div class="group-list" style="margin-left:-2px;height:124px;position:relative;padding-right: 10px;">
    <div
      v-for="(bookmark,i) in userBookmarks.data"
      class="card-container" style="position:relative" v-if="bookmark.data"
      :key="i">
      <Card :padding="1">
        <div style="height:120px" @click="onRedirect(bookmark)">
          <div class="card-content">
            <Icon type="star-outline"/>
            <img style="width:100%;height:100%" :src="getAvatar(bookmark)"/>
          </div>
          <div style="padding:0 3px;">
            <p class="content-ellipsis">{{getTitle(bookmark)}}</p>
          </div>
        </div>
      </Card>
    </div>
    <div v-if="userBookmarks.length <= 0">
      <p style="color:#ddd;line-height:114px" align="center">No items to show</p>
    </div>
    <div class="card-container" v-if="userBookmarks.next_link"  @click="loadMore">
      <Card :padding="1">
        <div style="height:120px">
          <div class="card-content" style="background:#fff;height:120px;text-align:center">
            <Spin fix v-if="isLoading">
              <Icon type="load-c" class="demo-spin-icon-load"></Icon>
              <div>Loading</div>
            </Spin>
            <div v-if="!isLoading">
                <Icon type="plus" style="display:block;line-height:85px;color:#ddd" size="50" />
                <p style="color:#ddd;" align="center">Load more</p>
            </div>
          </div>
        </div>
      </Card>
    </div>
  </div>
</template>

<script>
import Utils from '@/utils.js'
import moment from 'moment'

export default {
  name: 'CardViewBookmarks',
  data() {
    return {
      isLoading: false
    }
  },
  methods: {
    getAvatar(stuff) {        
        if(stuff && stuff.type && stuff.type == 'person' && stuff.data.avatar){
            return stuff.data.avatar
        }else if(stuff && stuff.data && stuff.data.cover_photo_uri){
            return Utils.getDisplayImage('activity', stuff.data, 'medium')
        }
        return null
    },
    getTitle(item) {
        if(item && item.type && item.type == 'person'){
            return item.data.display_name
        }else if(item && !item.data){
            return ''
        }else{
            return item.data.title
        }
    },
    onRedirect (data) {
      if (data.type == 'careplan_item') {
        if (data.data.type != 'directory') {
          this.$router.push({ path: '/feed/' + data.data.id })
        } else {
          this.$router.push({
            path:
              '/directory?slug=' +
              data.data.data.directory_type_slug +
              '&filter=' +
              data.data.data.category_slug
          })
        }
      } else if (data.type == 'person') {
        this.$router.push({ path: '/profile/' + data.data.id })
      }
    },
    loadMore(){
        this.isLoading =true;
        if (this.userBookmarks.next_link)
            this.$store.dispatch("user/loadMore", {
              link: this.userBookmarks.next_link,
              type: "bookmark"
        }).then( res=> {
            this.isLoading = false
            }, err=> {
            this.isLoading = false
        });
    }
  },
  computed: {
    info: {
      get() {
        return this.$store.state.publicProfile.info
      }
    },
    userBookmarks: {
      get () {
        return this.$store.state.user.userBookmarks
      }
    }
  },
  mounted(){
  }
}
</script>

<style scoped>
  .stroked-star {
    -webkit-text-stroke: 1px;
    -webkit-text-stroke-color: #494f61;
  }
  .star-org {
    position:absolute;
    z-index: 1;
    left: 1px;
    top: 1px;
    border-bottom-right-radius: 5px;
    text-align: center;
    width: 25px;
    height: 25px;
    background: #fff;
  }
  .event-holder {
    position: absolute;
    z-index: 1;
    left: 2px;
    top: 2px;
    text-align: center;
    width: 85px;
    height: 85px;
    background: rgba(255, 255, 255, 0);/*set tranparency*/
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .card-content {
    width:85px;
    height:85px;
    overflow:hidden;
    background:#f2f2f2;
  }
  .content-ellipsis {
    width: 80px;
    font-size: 12px;
    padding-top: 3px;
    display: block;
    display: -webkit-box;
    line-height: 1.25em;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    white-space: pre-line;
    text-overflow: ellipsis;
  }
  .group-list {
    overflow-x: scroll;
    overflow-y: hidden;
    white-space: nowrap;
    -webkit-overflow-scrolling: touch;
  }
  .card-container {
    vertical-align: top;
    width: 90px;
    display: inline-block;
    margin-left: 10px;
  }
</style>
